module.exports = __webpack_public_path__ + "static/nelson-mandela-c5d31f596def448d3daa5bfe03c6430d.jpg";